import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import languageEN from "./locate/en/translate.json";
import languageHN from "./locate/hn/translate.json";
import languageBEN from "./locate/bengali/translate.json";
import languageMAR from "./locate/marathi/translate.json";
import languagePUN from "./locate/punjabi/translate.json";
import languageTEL from "./locate/telugu/translate.json";
import languageASM from "./locate/assamese/translate.json";
import languageKAN from "./locate/kannada/translate.json";
import languageMAL from "./locate/malayalam/translate.json";
import languageTAM from "./locate/tamil/translate.json";
import languageUR from "./locate/urdu/translate.json";
import languageMANI from "./locate/manipuri/translate.json";
import languageODI from "./locate/odiya/translate.json";
import languageGUJ from "./locate/gujarati/translate.json";
import languageBHOJ from "./locate/bhojpuri/translate.json";
import languageENNEW from './locate/newUiLocate/en/translate.json'
import languageHNNEW from './locate/newUiLocate/hn/translate.json'
import languageBENNEW from './locate/newUiLocate/bengali/translate.json'
import languageMARNEW from './locate/newUiLocate/marathi/translate.json'
import languagePUNNEW from './locate/newUiLocate/punjabi/translate.json'
import languageTELNEW from './locate/newUiLocate/telugu/translate.json'
import languageASMNEW from './locate/newUiLocate/assamese/translate.json'
import languageKANNEW from './locate/newUiLocate/kannada/translate.json'
import languageMALNEW from './locate/newUiLocate/malayalam/translate.json'
import languageTAMNEW from './locate/newUiLocate/tamil/translate.json'
import languageURNEW from './locate/newUiLocate/urdu/translate.json'
import languageMANINEW from './locate/newUiLocate/manipuri/translate.json'
import languageODINEW from './locate/newUiLocate/odiya/translate.json'
import languageGUJNEW from './locate/newUiLocate/gujarati/translate.json'
import languageBHOJNEW from './locate/newUiLocate/bhojpuri/translate.json'
import { isNewUI } from "./utils/handleProgress";

const resources = {
  eng: { translation: languageEN },
  hin: { translation: languageHN },
  Bengali: { translation: languageBEN },
  Marathi: { translation: languageMAR },
  Punjabi: { translation: languagePUN },
  Telugu: { translation: languageTEL },
  Assamese: { translation: languageASM },
  Malayalam: { translation: languageMAL },
  Kannada: { translation: languageKAN },
  Tamil: { translation: languageTAM },
  Urdu: { translation: languageUR },
  Odiya: { translation: languageODI },
  Manipuri: { translation: languageMANI },
  Gujarati: { translation: languageGUJ },
  Bhojpuri: { translation: languageBHOJ }

};

const resourcesNewUi = {
  eng: { translation: { ...languageEN, ...languageENNEW } },
  hin: { translation: { ...languageHN, ...languageHNNEW } },
  Bengali: { translation: { ...languageBEN, ...languageBENNEW } },
  Marathi: { translation: { ...languageMAR, ...languageMARNEW } },
  Punjabi: { translation: { ...languagePUN, ...languagePUNNEW } },
  Telugu: { translation: { ...languageTEL, ...languageTELNEW } },
  Assamese: { translation: { ...languageASM, ...languageASMNEW } },
  Malayalam: { translation: { ...languageMAL, ...languageMALNEW } },
  Kannada: { translation: { ...languageKAN, ...languageKANNEW } },
  Tamil: { translation: { ...languageTAM, ...languageTAMNEW } },
  Urdu: { translation: { ...languageUR, ...languageURNEW } },
  Odiya: { translation: { ...languageODI, ...languageODINEW } },
  Manipuri: { translation: { ...languageMANI, ...languageMANINEW } },
  Gujarati: { translation: { ...languageGUJ, ...languageGUJNEW } },
  Bhojpuri: { translation: { ...languageBHOJ, ...languageBHOJNEW } }

};


i18n.use(initReactI18next).init({
  // resources: isNewUI() ? resourcesNewUi : resources,
  resources: resourcesNewUi,
  lng: localStorage.getItem("LanguageSelected"),
  // lng: "eng",
  fallbackLng: "eng",
  /* default language when load the website in browser */

  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
